import Language from '../../job/Instructions/Language'
import TextHelper from '../../../../utils/text'
import {useNamespaceTranslations} from '../../../../utils/hooks/useNamespacesTranslations'

const OBJECT = 'object'
const CONFIG_FILE = ':config_file'
const REPLACED_CHARS = [':telemetry_url', ':metric_type']

const replaceSpecificPlaceholders = (data, placeholder, replacement) => {
    if (Array.isArray(data)) {
        return data.map((item) =>
            item?.type === placeholder ? replacement : item
        )
    }
    if (typeof data === OBJECT && data !== null) {
        return Object.fromEntries(
            Object.entries(data).map(([key, value]) => [
                key,
                replaceSpecificPlaceholders(value, placeholder, replacement)
            ])
        )
    }
    return data
}

const getSelectedMetricTypesText = (selectedMetricTypes) => {
    return Object.values(selectedMetricTypes)
        .flatMap((values) => values?.child_items?.map((value) => value?.code))
        .join('\n')
}

const ConfigFileComponent = ({data, language, url, selectedMetricTypes}) => {
    const text = useNamespaceTranslations('server-monitoring')
    const selectedMetricTypesText = getSelectedMetricTypesText(selectedMetricTypes)
    const telemetryConfig = {
        ...text.general_config_code,
        code: TextHelper.replaceAllChars(
            text?.general_config_code?.code,
            REPLACED_CHARS,
            [url, selectedMetricTypesText || text.no_metrics_enabled]
        )
    }

    const modifiedData = replaceSpecificPlaceholders(
        data,
        CONFIG_FILE,
        telemetryConfig
    )

    return (
        <div className="docs-container">
            <Language data={modifiedData} language={language} isOs />
        </div>
    )
}

export default ConfigFileComponent
